import React, { FC, useCallback, useEffect, useState } from 'react'
import ReactSelect from 'react-select'
import classNames from 'classnames'
import { useField } from 'formik'
import { styles as stylesV1 } from '@components/form/selects/select/styles'

import { LocationsApi, City } from '@services/api/locations'

import { FieldError as ErrorForm, styles } from '@components/form'
import { FieldProps } from '@components/form/types'
import { styles as stylesV2 } from '@components/form/selects/select/styles-v2'

interface Option {
  label: string
  value: any
}
interface Props extends FieldProps {
  onlyValue?: boolean
  stateId: number
  cityId?: number
  className?: string
  disabled?: boolean
  placeholder?: string
  tabIndex?: number
  customStyle?: 'v1' | 'v2'
}

export const SelectCity: FC<Props> = ({
  name,
  onlyValue = false,
  label,
  stateId,
  cityId,
  container: { className: containerClassName, ...container } = {},
  error,
  disabled,
  placeholder,
  tabIndex,
  customStyle = 'v1',
  ...props
}) => {
  const [cities, setCities] = useState<Option[]>([])
  const [, meta, helpers] = useField(name)
  const [value, setValue] = useState<Option>()

  const converteStateForOptionSelect = (states: City[]) => {
    return states.map(state => {
      return {
        label: state.name,
        value: state.id
      }
    })
  }

  const getCities = useCallback(
    async _stateId => {
      setValue(null)
      if (!_stateId) {
        return
      }

      const { data } = await LocationsApi.cities(_stateId)
      const optionsCities = converteStateForOptionSelect(data.cities)

      setCities(optionsCities)
    },
    [stateId, cityId]
  )

  const findCityById = (id: number) => {
    if (!id) {
      return
    }
    const city = cities.find(city => city.value === id)
    setValue(city)
  }

  useEffect(() => {
    getCities(stateId)
  }, [stateId])

  useEffect(() => {
    findCityById(cityId)
  }, [stateId, cities, cityId])

  return (
    <div
      className={classNames(styles.groupInput, containerClassName)}
      {...container}
    >
      {label}
      <ReactSelect
        id={name}
        instanceId={name}
        name={name}
        placeholder={placeholder || ''}
        options={cities}
        value={value}
        noOptionsMessage={() => 'Nenhuma cidade'}
        onChange={optionSelected => {
          helpers.setValue(onlyValue ? optionSelected?.value : optionSelected)
          setValue(optionSelected)
        }}
        styles={customStyle === 'v1' ? stylesV1() : stylesV2()}
        isDisabled={disabled}
        tabIndex={tabIndex}
        menuShouldScrollIntoView={false}
        {...props}
      />
      <ErrorForm touched={meta.touched} error={meta.error} {...error} />
    </div>
  )
}
